import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/motion";
import { Section, Eyebrow } from "@/components/kit";
import { useLang } from "@/i18n/LanguageContext";

// Sección de preguntas del público (FAQ)
export const Faq = ({ alt = false }) => {
  const { t } = useLang();
  const items = t("faq.items");

  return (
    <Section alt={alt} id="faq">
      <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <Reveal>
          <Eyebrow color="#81D4FA">{t("faq.eyebrow")}</Eyebrow>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold leading-none tracking-tighter text-ink">
            {t("faq.title")}
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="overflow-hidden rounded-2xl border border-ink/10 bg-white px-5"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-display text-lg font-bold text-ink hover:no-underline"
                >
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-base text-ink/70 leading-relaxed">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </Section>
  );
};
